import { createAction } from 'redux-actions-helpers';

export const getTournamentsStart = createAction('@@tournaments/GET_START');
export const resetTournaments = createAction('@@tournaments/GET_RESET');
export const getTournamentsSuccess = createAction('@@tournaments/GET_SUCCESS', (payload) => ({ payload }));
export const searchEvent = createAction('@@tournaments/SEARCH_EVENT', (payload) => ({ payload }));
export const tournamentsReorder = createAction('@@tournaments/REORDER', ({ startIndex, endIndex, gameId }) => ({
    startIndex,
    endIndex,
    gameId
}));
export const deleteEvent = createAction('@@tournaments/DELETE', (event) => ({
    event
}));



// WEBPACK FOOTER //
// ./src/blocks/tournaments/actions.js